export default __webpack_public_path__ + "static/media/Products.1c97bf1e.svg";